import { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Avatar from 'src/components/avatar';
import { showSignupModal } from 'src/modules/shared/modal/actions';
import signupContext from 'src/constants/signupContext';
import { trackFootfallEvent } from 'src/utils/footfall';
import footfallEventTypes from 'src/constants/footfallEventTypes';
import i18n from 'src/utils/translate';
import linkUtils from 'src/utils/linkUtils';
import styled from 'styled-components';

export class UserLink extends Component {
  static propTypes = {
    user: PropTypes.object.isRequired,
    avatar: PropTypes.bool,
    avatarSize: PropTypes.string,
    className: PropTypes.string,
    isLoggedIn: PropTypes.bool,
    isTargetBlank: PropTypes.bool,
    signupContext: PropTypes.object,
    onClick: PropTypes.func,
  };

  static defaultProps = {
    avatar: false,
    isTargetBlank: false,
    signupContext: {
      section: signupContext.section.UNTRACKED,
      element: signupContext.element.USER_LINK,
    },
    isLoggedIn: true,
    onClick: () => {},
  };

  onClick = event => {
    this.props.onClick();
    if (!this.props.isLoggedIn) {
      event.preventDefault();
      trackFootfallEvent(footfallEventTypes.CLICKED, {
        clickType: 'sign-up',
        clickMetadata: this.props.signupContext,
      });
      this.props.showSignupModal(this.props.signupContext);
      return;
    }
  };

  render() {
    const { avatar, avatarSize, className, isTargetBlank, user } = this.props;
    const username = user.username || '';
    const url = isTargetBlank ? `${window.location.protocol}//${window.location.host}` : `/user/${username}`;
    let avatarSrc;
    if (user.avatar) {
      avatarSrc = user.avatar;
    } else if (user.profileImageSmall) {
      avatarSrc = user.profileImageSmall;
    } else {
      avatarSrc = linkUtils.generateAvatarLinkFromHash(user.userImageHash);
    }

    const isLoading = !username;
    const isHiddenOrDeleted = !user || (Object.keys(user).length > 0 && user.isDeleted) || (Object.keys(user).length > 0 && user.isHidden) || username === 'Hidden';
    const contentText = isHiddenOrDeleted ? i18n.t('Hidden') : isLoading ? i18n.t('Loading...') : username;
    const content = avatar ? <Avatar name={username} size={avatarSize} src={avatarSrc} /> : contentText;

    // Show loading user as loading
    if (isLoading) {
      return (
        <span className={className}>
          {!avatar && contentText}
        </span>
      );
    }

    // Open Help Scout article for hidden/deleted users
    if (isHiddenOrDeleted) {
      return (
        <ArticleButton className={className} onClick={() => {
          window.HelpscoutBeacon.triggerHelpScoutArticle('173-what-are-hidden-accounts');
        }}>
          {content}
        </ArticleButton>
      );
    }

    return (
      <a
        className={className}
        href={url}
        rel="nofollow"
        target={isTargetBlank ? '_blank' : null}
        onClick={this.onClick}
      >
        {content}
      </a>
    );
  }
}

export default connect(null, { showSignupModal })(UserLink);

const ArticleButton = styled.button`
  border: 0;
  padding: 0;
  -webkit-appearance: none;
  background-color: transparent;
`;
